import { render, staticRenderFns } from "./CompetitorsPanel.vue?vue&type=template&id=cd7007e6&"
import script from "./CompetitorsPanel.vue?vue&type=script&lang=js&"
export * from "./CompetitorsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports